import React, { useState } from "react";
import { User, Camera } from "lucide-react";

import Text from "../../../../components/typography/Text";

import "./TalentAvatar.css";

const getInitials = (name) =>
  String(name ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

export default function TalentAvatar({
  profile,
  size = "medium",
  onUpload,
  disabled = false,
  className = "",
}) {
  const [failedUrl, setFailedUrl] = useState(null);

  const name = profile?.name || "";
  const avatarUrl = profile?.avatarUrl || profile?.profileImageUrl || null;

  const showImage = Boolean(avatarUrl) && failedUrl !== avatarUrl;
  const initials = getInitials(name);

  return (
    <div
      className={["talent-avatar", `talent-avatar--${size}`, className]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="talent-avatar__image">
        {showImage ? (
          <img
            src={avatarUrl}
            alt={name ? `${name}'s profile photo` : "Talent profile photo"}
            loading="lazy"
            decoding="async"
            onError={() => setFailedUrl(avatarUrl)}
          />
        ) : initials ? (
          <Text
            as="span"
            className="talent-avatar__initials"
            aria-hidden="true"
          >
            {initials}
          </Text>
        ) : (
          <User className="talent-avatar__fallback" aria-hidden="true" />
        )}
      </div>

      {onUpload && (
        <button
          type="button"
          className="talent-avatar__upload"
          onClick={onUpload}
          disabled={disabled}
          aria-label="Change profile photo"
          title="Change profile photo"
        >
          <Camera size={16} aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
